
import React, { Component } from "react";

import { Menu } from 'antd';

import '../css/widget/widget.pagination.css'

class WidgetMenu extends Component 
{
    constructor (props) {
        super(props);

        this.state = {
            values: props.values,
            items: props.items,
            openKeys:[]
        }
    }

    onClick = (item, key, keyPath, domEvent) => {

        this.setState({values:[key]});

        if( this.props.notify )
        {
            this.props.notify(item, key, keyPath);
        }
    }

    componentWillReceiveProps( nextProps )
    {
        this.setState({values:nextProps.values, items:nextProps.item}, () => {
            this.buildOpenKeys();
        })
    }

    buildOpenKeys = () => {
        
        const { values=[], items} = this.state;

        let openKeys = [];

        for(let value of values)
        {
            this.findOpenKey(openKeys, items, value);
        }

        this.setState({openKeys:openKeys});

    }

    /**
	 * 根据点击节点找到需要展开的节点的key
	 * @param {*} leftNode 
	 * @param {*} activeKey 
	 */
	findOpenKey = (openKeys, items, activeKey) => {

		let isFind = false;

		if (items !== undefined && items !== null) 
        {
			for (let i = 0; i < items.length; i++) 
            {
				// 查父级
				if( items[i].value === activeKey ) 
                {
					isFind = true;
				}
				//  若父级未找到，查子集
				if( isFind === false && items[i].children !== undefined) 
                {
					isFind = this.findOpenKey(openKeys, items[i].children, activeKey);
				}

				if( isFind === true) 
                {
					openKeys.push(items[i].value);
					break;
				}
			}
		}

		return isFind;
	}


    render() 
    {
        const { openKeys, values=[] } = this.state;

        const {items, mode ="inline"} = this.props;

        return  (
            <div className="sf-widget-menu sd-widget-menu sg-widget-menu">
                <Menu
                    onClick={this.onClick}
                    style={{ width: '100%' }}
                    defaultSelectedKeys={values}
                    defaultOpenKeys={openKeys}
                    mode={mode}
                    items={items}
                />
            </div>
        )
    }
}

export default WidgetMenu;